import React from "react";
import TopDestinations from "../../Components/Tour/TopDestinations";
import TrendingTour from "../../Components/home/TrendingTours";
import OurRecords from "../../Components/Tour/OurRecords";
import VehicleService from "../../Components/Tour/VehicleService";
import SimpleBanner from "../../Screens/Common/SimpleBanner";
import TourBanner from "../../Assets/Tour/tourBg.png";
import Newsletter from "../../Components/home/Newsletter";
import { Helmet } from "react-helmet";

const Tour = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>Bhubaneswar Tour Packages – Book Taxi with GoCabz</title>
        <meta
          name="description"
          content="Explore Bhubaneswar with GoCabz tour packages. Affordable taxi booking for sightseeing, temple
tours, and customized trips across Odisha."
        />
        <link rel="canonical" href="https://www.gocabz1.com/tour/" />
      </Helmet>
      <SimpleBanner
        image={TourBanner}
        name="Our Tours"
        path="Home / Our Tours"
      />

      <TopDestinations />
      <TrendingTour />
      <OurRecords />
      <VehicleService />
      <Newsletter />
    </div>
  );
};

export default Tour;
